import script from "./CallStage.vue?vue&type=script&setup=true&lang=js"
export * from "./CallStage.vue?vue&type=script&setup=true&lang=js"

import "./CallStage.vue?vue&type=style&index=0&id=d836d676&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d836d676"]])

export default __exports__